// extracted by mini-css-extract-plugin
module.exports = {"dialog":"lhSNfONvwCSR68rGw5ZmK","body":"_2H9hso65MB3m1tC65IZRYq","buttonRow":"_1368aF74xFik5Pna9AtD8C"};